<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <non-trend-chart ref="chartInstance"
                         class="widget-contents-chart"
                         :type="opts.chartType"
                         :x-axis="xAxis"
                         :y-axis="yAxis"
                         :tooltip="toolTip"
                         :data="widgetData"
                         :series-options="seriesOptions"
        />
      </div>
    </div>
  </div>
</template>
<script>
  // Mixin 객체
  import { widgetMixin } from '~/mixins/widgetCommonMixin'

  // 스토어 헬퍼
  import { createNamespacedHelpers } from 'vuex'

  // 스토어 헬퍼 객체
  const { mapActions } = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetSysVlanTrafTopn',
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 2,
        self: this,
        opts: {
          chartType: 'bar'
        },
        title: 'widgetSysVlanTrafTopn',
        haType: 'all',
        isLock: false,
        isMove: true,
        isResize: true,
        eventBus: true,
        deviceType: [20],
        restData: {
          result: [],
          unit_time: ''
        },
        seriesOptions: {
          barWidth: '40%'
        },
        widgetData: []
      }
    },
    props: {},
    computed: {
      // xAxis () {
      //   return {
      //     type: 'category',
      //     labels: {
      //       formatter () {
      //         return `ID ${this.value}`
      //       }
      //     }
      //   }
      // },
      // yAxis () {
      //   const self = this.self
      //   return {
      //     title: '',
      //     labels: {
      //       nStep: self.opts.chartType === 'bar' ? 2 : void 0,
      //       style: {
      //         textOverflow: 'ellipsis'
      //       },
      //       rotation: 0,
      //       formatter () {
      //         return self.byteConverter(this.value)
      //       }
      //     },
      //     softMin: 0,
      //     softMax: 1
      //   }
      // },
      xAxis () {
        const xAxisOptions = {}

        if (this.opts.chartType === 'bar') {
          xAxisOptions.axisLabel = {
            formatter: (value) => {
              return `${this.byteConverter(value)}`
            }
          }
        }
        if (this.opts.chartType === 'column') {
          xAxisOptions.axisLabel = {
            formatter: (value) => {
              return `ID ${value}`
            }
          }
        }

        return xAxisOptions
      },
      yAxis () {
        const yAxisOptions = {}

        if (this.opts.chartType === 'column') {
          yAxisOptions.axisLabel = {
            formatter: (value) => {
              return `${this.byteConverter(value)}`
            }
          }
        }
        if (this.opts.chartType === 'bar') {
          yAxisOptions.axisLabel = {
            formatter: (value) => {
              return `ID ${value}`
            }
          }
        }

        return yAxisOptions
      },
      toolTip () {
        return {
          formatter: (params) => {
            const {name, value, marker} = _.isArray(params) ? params[0] : params
            return `${marker} ID ${name} : <b>${this.byteConverter(value)}${this.restData.unit_time}</b>`
          }
        }
      },
      chartInstance () {
        return this.$refs.chartInstance
      },
      widgetChartMenu () {
        return [
          {
            icon: 'icon-chart-bar',
            label: 'Bar Chart',
            value: 'bar'
          },
          {
            icon: 'icon-chart-column',
            label: 'Column Chart',
            value: 'column'
          }
        ]
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        const contentsOptions = {
          widgetType: 'vlan_traffic_top'
        }

        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        /*
          IP 타입 및 HA 멤버 파라미터 설명

          NGF 1.2.0 부터 대시보드의 모든 위젯은 각자 IP Type 및 HA 멤버에 대한 API 요청을 개별로 수행한다. IP Type 및 HA
          Member 선택 시 데이터를 다시 불러온다.
        */
        if (this.opts.haMember) {
          contentsOptions.dataType = this.opts.haMember
        }
        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (IP Type 또는 HA Mamber/Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams) {
          if (extraParams.haMember) {
            contentsOptions.dataType = extraParams.haMember
          }

          if (extraParams.machId) {
            contentsOptions.machId = extraParams.machId
          }
        }

        // API 호출
        const { code, result } = await this.getWidgetData(contentsOptions)
        // Series 데이터 구성
        if (code === 'ok') {
          const vlanTrafficList = []
          for (const { name, value } of result.result || []) {
            vlanTrafficList.push({
              name,
              value
            })
          }
          this.widgetData = vlanTrafficList
        }

        // Progress 출력 여부
        this.showProgress(false)
      }
    },
    watch: {}
  }
</script>

<style scoped>
</style>
